import { usePhasesQuery } from './usePhasesQuery';
import { usePhasesSearch } from './usePhasesSearch';
import { usePhasesTableColumns } from './usePhasesTableColumns';

export const usePhases = (filters: Record<string, string> = {}) => {
    const { data: items = [], isLoading: loading } = usePhasesQuery(filters);
    const { keyword } = usePhasesSearch();
    const { columns } = usePhasesTableColumns();

    // Filter items based on keyword (client-side filtering)
    const visibleItems = items.filter(item =>
        !keyword ||
        item.name?.toLowerCase().includes(keyword.toLowerCase()) ||
        item.description?.toLowerCase().includes(keyword.toLowerCase())
    );

    return {
        items,
        visibleItems,
        loading,
        columns,
    };
};
